var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('iframe',{attrs:{"src":_vm.url}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }